import { BaseLayout } from "components/Layouts/BaseLayout/BaseLayout.tsx";
import { usePageMeta } from "hooks/usePageMeta";
import { useUser } from "hooks/useUser.ts";
import { FC, PropsWithChildren } from "react";

export const TenantLayout: FC<PropsWithChildren> = ({ children }) => {
    const { getActiveTenant } = useUser();
    const activeTenant = getActiveTenant();

    usePageMeta(activeTenant?.title ?? "Paldock");

    return <BaseLayout>{children}</BaseLayout>;
};
